import axios from "axios";
import {BaseResponse} from "../../BaseResponse";

export async function deleteTankRelease(tankReleaseId: string) {
    const response = await axios.delete<BaseResponse<boolean>>(`/tank/release/${tankReleaseId}`)

    return response.data
}